import React, {useState, useMemo} from "react";
import PropTypes from "prop-types";
import {default as MuiButton} from "@mui/material/Button";
import {default as MuiIconButton} from "@mui/material/IconButton";
import Dialog from "components/Shared/Button/Dialog";

const Button = ({
  dialogProps: {onClose, ...otherDialogProps} = {}, // = {} fix for typescript files using this button
  icon = null,
  children,
  ...otherProps
}) => {
  const [open, setOpen] = useState(false);
  const dialogEnabled = useMemo(
    () => otherDialogProps && otherDialogProps.title,
    [otherDialogProps]
  );
  const ButtonComponent = useMemo(
    () => icon
      ? MuiIconButton
      : MuiButton,
    [icon]
  );
  const onClick = e => {
    e && e.stopPropagation();
    otherProps.onClick();
  };
  return (
    <>
      <ButtonComponent
        {...otherProps}
        children={icon || children}
        onClick={dialogEnabled ? (
          (e) => {
            e.stopPropagation();
            setOpen(true);
          }
        ) : (
          onClick
        )}
        variant={"contained"}
        color={"primary"}
      />
      {dialogEnabled &&
        <Dialog
          className="button-inline-dialog"
          {...otherDialogProps}
          {...{ open }}
          onClick={() => {
            otherProps.onClick();
            setOpen(false);
          }}
          onClose={() => {
            onClose && onClose();
            setOpen(false);
          }}
        />}
    </>
  );
};

Button.defaultProps = {
  onClick: () => {},
  dialogProps: {},
  icon: null,
};

Button.propTypes = {
  //Callback for OnClick
  onClick: PropTypes.func,
  children: PropTypes.node,

  //All Mui Dialog props https://material-ui.com/components/dialogs/
  //In addition 
  //"title" - text in the dialog header
  //children - content of dialog
  dialogProps: PropTypes.object,
};

export default Button;